export default function callMethod(method, ...params){
	return function (instance){
		if (instance)
			return instance[method](...params);
	};
}
